import domToImage from 'dom-to-image-more';
import { message } from 'antd';
import { exportChart } from '../../explore/exploreUtils';

import { generateRandomString as generateRandomString1 } from '@gainer-ui/ai-bi-chat';
export const generateRandomString = generateRandomString1;

export const generateInputBody = (
  input,
  chat_history,
  conversationId,
  roundId,
  topic,
  topic_id,
  enable_hil,
) => {
  function getCookie(name) {
    // 将 Cookie 字符串分割为数组
    const cookies = document.cookie.split(';');

    // 遍历查找目标 Cookie
    for (const cookie of cookies) {
      // 去除空格并分割键值对
      const [key, value] = cookie.trim().split('=');

      // 解码并比对 Cookie 名称
      if (decodeURIComponent(key) === name) {
        return decodeURIComponent(value);
      }
    }

    return null; // 未找到返回 null
  }

  const session = getCookie('session');
  if (!session) {
    console.warn('未获取到session');
  }
  const csrf = localStorage.getItem('csrfToken');
  if (!csrf) {
    console.warn('未找到csrfToken');
  }
  return {
    content: input,
    conversation_id: conversationId || generateRandomString(),
    round_id: roundId || generateRandomString(),
    topic,
    topic_id,
    enable_hil,
  };
  // return {
  //   input: {
  //     input,
  //     topic: 2,
  //     user_id: '1',
  //     username: 'admin',
  //     csrf,
  //     cookies: { session },
  //     conversation_id: '',
  //     round_id: generateRandomString(),
  //     chat_history,
  //   },
  // };
};

export const deepClone = (obj, hash = new WeakMap()) => {
  if (obj === null) return null;
  if (obj instanceof Date) return new Date(obj);
  if (obj instanceof RegExp) return new RegExp(obj);
  if (typeof obj !== 'object') return obj;
  if (hash.has(obj)) return hash.get(obj); // 处理循环引用

  const clone = Array.isArray(obj) ? [] : {};
  hash.set(obj, clone); // 存储原始对象和其对应的克隆对象

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      clone[key] = deepClone(obj[key], hash);
    }
  }
  return clone;
};

/**
 * 图表转换表格
 * @param {object} param0
 * @param param0.format
 * @param {boolean=} param0.isFullCSV
 * @param {boolean=} param0.isPivot
 * @param {number=} param0.slice_id
 * @param {boolean=} param0.isCached
 * @param param0.formData
 * @param {number=} param0.row_limit
 * @param {object=} param0.ownState
 */
export const exportTable = ({
  format,
  isFullCSV,
  isPivot = false,
  slice_id,
  isCached,
  formData,
  row_limit,
  ownState,
}) => {
  exportChart({
    formData: isFullCSV ? { ...formData, row_limit } : formData,
    resultType: isPivot ? 'post_processed' : 'full',
    resultFormat: format,
    force: true,
    ownState,
  });
};

/**
 * 导出指定元素为图片
 * @param elementRef - 需要导出的元素的 ref
 * @param filename - 下载的文件名 (默认 'chart.png')
 * @param {object=} options - 额外的导出配置 (可选)
 */
export const exportChartToImage = (elementRef, filename, options) => {
  if (!elementRef.current) {
    message.error('导出失败：元素不存在');
    return;
  }

  domToImage
    .toPng(elementRef.current, {
      quality: 1, // 图片质量 (1 为最高)
      bgcolor: 'white', // 背景色，防止透明
      ...options,
    })
    .then(dataUrl => {
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = filename;
      link.click();
    })
    .catch(error => message.error('导出失败:', error));
};

export const CACHE_AUDIO_KEY = 'gainer_cache_audio';
/**
 * 缓存语音
 * 格式: [{ conversationId, audios: { 'roundId': [{ text: '', url: '' }] } }]
 * @param params { conversationId: '', roundId: '', text: '', base64: '' }
 */
export const cacheAudio = params => {
  if (!params || !params.conversationId || !params.key || !params.base64)
    return;

  const cacheAudioString = localStorage.getItem(CACHE_AUDIO_KEY);
  const cacheAudio = cacheAudioString ? JSON.parse(cacheAudioString) : [];

  const conversation = cacheAudio.find(
    item => item.conversationId === params.conversationId,
  );

  const obj = { text: params.text, base64: params.base64 };
  if (conversation) {
    // 如果该 key 已存在，追加；否则新建
    if (conversation.audios?.[params.key]) {
      conversation.audios[params.key].push(obj);
    } else {
      conversation.audios[params.key] = [obj];
    }
  } else {
    // 新建 conversation 缓存
    cacheAudio.push({
      conversationId: params.conversationId,
      audios: {
        [params.key]: [obj],
      },
    });
  }

  localStorage.setItem(CACHE_AUDIO_KEY, JSON.stringify(cacheAudio));
};

/**
 * 获取缓存的语音
 * @param {Object} params
 * @param {string|number} params.conversationId - 会话 ID
 * @param {string|number} params.key - 唯一索引
 * @returns {Array<{text: string; base64: string}>|null} - 返回该 key 下缓存的语音数组，或者 null
 */
export const getCacheAudio = ({ conversationId, key }) => {
  if (!conversationId || !key) return null;

  const cacheAudioString = localStorage.getItem(CACHE_AUDIO_KEY);

  // 如果没有缓存
  if (!cacheAudioString) return null;

  try {
    const cacheAudio = JSON.parse(cacheAudioString);

    // 查找是否有对应的 conversationId 的记录
    const conversation = cacheAudio.find(
      item => item.conversationId === conversationId,
    );

    // 如果找到了对应会话，并且存在该 key 的音频数据
    if (conversation && conversation.audios && conversation.audios[key]) {
      return conversation.audios[key]; // 返回音频数组
    }

    return null;
  } catch (error) {
    console.error('Failed to parse CACHE_AUDIO_KEY:', error);
    return null;
  }
};

/**
 * 将 base64 音频字符串转换为可播放的 audio URL
 * @param {string} base64Str - 含 data URI 的 base64 字符串
 * @param {string} [mimeType='audio/wav'] - 可选 MIME 类型
 * @returns {string} 可用于 <audio> 播放的 blob URL
 */
export function base64ToAudioUrl(base64Str, mimeType = 'audio/wav') {
  try {
    const cleanBase64 = base64Str.replace(/^data:audio\/\w+;base64,/, '');
    const binary = atob(cleanBase64);
    const buffer = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      buffer[i] = binary.charCodeAt(i);
    }
    const blob = new Blob([buffer], { type: mimeType });
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error('base64 转音频失败:', error);
    return '';
  }
}

/**
 * 文字是否可读
 * @param str
 * @returns {boolean}
 */
export const hasReadableText = str => {
  if (typeof str !== 'string') return false;
  // 先检测中文、英文、数字
  if (/[\u4e00-\u9fa5a-zA-Z0-9]/.test(str)) return true;
  // 再检测 Unicode 字母和数字（支持多语言字符）
  if (/[\p{L}\p{N}]/u.test(str)) return true;
  // 最后检测是否含有非空白字符（空格、换行等除外）
  if (/\S/.test(str)) return true;
  return false;
};

/**
 * 判断是否没有主题权限
 * @param {number=} topicType 当前对话主题id
 * @param {Array<{id: number, name: string}>=} topicTypeList 用户主题列表
 * @returns
 */
export const isNoTopic = (topicType, topicTypeList) => {
  if (topicType) {
    return topicTypeList.find(item => item.id == topicType) === undefined;
  }
  return false;
};
